export default {
  name: 'IconBlitz',
  props: {
    color: { type: String, default: 'rgb(0,0,0)' }, // любой CSS-цвет
    size:  { type: String, default: '1em' },        // 'px' | 'em' | 'rem'
    tooltipEnabled: { type: Boolean, default: true },
  },
  computed: {
    tooltipOptions() {
      return {
        value: this.$t('controls.blitz'),
        class: 'tt-sm',
        disabled: !this.tooltipEnabled,
      };
    },
  },
};
